export default __webpack_public_path__ + "static/media/governance.bc3f2f3c.jpg";